import React from "react";

export const Training = (props) => {
  return (
    <div id="training">
      <div className="container">
        <div className="section-header text-center">
          <div className="eyebrow">How We Work</div>
          <h2>A Proven Approach to Network Excellence</h2>
        </div>
        <div className="process-steps">
          {props.data && props.data.steps
            ? props.data.steps.map((step, i) => (
                <div key={i} className="process-step">
                  <div className="process-number">{step.number}</div>
                  <h3 className="process-title">{step.title}</h3>
                  <p className="process-text">{step.text}</p>
                </div>
              ))
            : null}
        </div>
      </div>
    </div>
  );
};
